import script from "./CoordenadasSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./CoordenadasSelect.vue?vue&type=script&setup=true&lang=js"

import "./CoordenadasSelect.vue?vue&type=style&index=0&id=cce31482&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cce31482"]])

export default __exports__